<template>
	<v-speed-dial
		v-model="fab"
		class="speed-dial"
		direction="top"
		transition="slide-y-reverse-transition"
		:fixed="fixed"
		:absolute="absolute"
		bottom
		right
	>
		<v-btn slot="activator" v-blur fab :small="small">
			<v-icon
				:class="['speed-dial--activator', { active: fab }]"
				color="rust-red"
				>fa-plus</v-icon
			>
		</v-btn>

		<template v-if="showFilter">
			<v-btn
				class="btn--hide"
				color="warm-blue"
				small
				fab
				@click="$emit('input', !value)"
			>
				<v-icon
					color="white"
					small
					v-text="value ? 'fas fa-check-square' : 'far fa-square'"
				/>
			</v-btn>
			<tippy to-selector=".btn--hide" v-bind="tippyAttrs">{{
				strings.devices.hideInstalled
			}}</tippy>
		</template>

		<template v-if="showAddRoom">
			<v-btn
				class="btn--add-room"
				color="ocean"
				small
				fab
				@click="$emit('action:addRoom')"
			>
				<v-icon color="white" small>fa-door-open</v-icon>
			</v-btn>
			<tippy to-selector=".btn--add-room" v-bind="tippyAttrs">{{
				strings.devices.addRoom
			}}</tippy>
		</template>

		<template v-if="showAddDevice">
			<v-btn
				class="btn--add-device"
				color="orange"
				small
				fab
				@click="$emit('action:addDevice')"
			>
				<v-icon color="white" small>fa-plug</v-icon>
			</v-btn>
			<tippy to-selector=".btn--add-device" v-bind="tippyAttrs">{{
				strings.devices.addDevice
			}}</tippy>
		</template>
	</v-speed-dial>
</template>

<style lang="scss" scoped>
.speed-dial {
	.speed-dial--activator {
		transition: transform 150ms ease;

		&.active {
			transform: rotate(135deg);
		}
	}
}
</style>

<script>
import strings from "@/utils/strings";

export default {
	props: {
		// Small activator button variant
		small: { type: Boolean, default: false },

		// Positioning
		fixed: { type: Boolean, required: false },
		absolute: { type: Boolean, required: false },

		value: { type: Boolean, default: false },
		showAddDevice: { type: Boolean, default: true },
		showAddRoom: { type: Boolean, default: true },
		showFilter: { type: Boolean, default: true },

		// Override tippy z-index
		tippyZ: { type: Number, required: false, default: null },
	},

	data: function() {
		return {
			strings,

			// Showing fab speed-dial
			fab: false,
			// Control showing/hiding of tooltips at appropriate time
			tooltips: false,
		};
	},

	computed: {
		// Repetitive attributes shared by tippy components
		tippyAttrs() {
			const retval = {
				visible: this.tooltips,
				trigger: "manual",
				placement: "left",
				hideOnClick: false,
			};

			if (this.tippyZ) retval.zIndex = this.tippyZ;

			return retval;
		},
	},

	watch: {
		fab(val) {
			this.tooltips = false;
			val &&
				setTimeout(() => {
					this.tooltips = true;
				}, 450);
		},
	},
};
</script>
